import { MenuKeys } from "../../menus/menu-keys";
import { ControllerContext } from "../controller";
import { ControllerContextKey } from "./contextKeys";

export const preStartContext: ControllerContext = {
  start: {
    onDown: (_e, ctx) => {
      console.log("Start button clicked");
      ctx.menuManager.pushMenu(MenuKeys.PreStartMenu);
      ctx.controller.pushContext(ControllerContextKey.PreStartMenu);
    },
  },
};
